import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminApi, authStore } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!authStore.get()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await adminApi.me();
      setUser(me);
    } catch {
      authStore.clear();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (username, password) => {
    const res = await adminApi.login(username, password);
    authStore.set(res.access_token);
    setUser({ username: res.username });
    return res;
  };

  const logout = () => {
    authStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
